<div class="metadata-view-navigation-list">
    <div ngModelGroup="menuView">
        <metadata-view *ngIf="menuView && !isHidden(menuView)" layout-fill [view]="menuView" [model]="model"
                       [viewOnly]="viewOnly" [datacontroller]="datacontroller" isMenu="true">
        </metadata-view>
        <forge-divider *ngIf="menuView && !isHidden(menuView)" style="padding: .5rem 0;"></forge-divider>
        <forge-select #shortcut *ngIf="hasShortcuts" class="dense-input metadata-padding" attr.aria-label="Form Menu Shortcut"
                      (change)="goToView($event.detail)" dense placeholder="Shortcuts...">
            <forge-option *ngFor="let shortcutView of shortcutViews"
                          [value]="shortcutView">{{shortcutView.label}}</forge-option>
        </forge-select>
        <metadata-navigation-tree [nodes]="nodes" (onClick)="select($event)" (onContextMenu)="context($event)">
        </metadata-navigation-tree>
    </div>
</div>
